const getPlacesNamespace = () => {
  if (typeof window === "undefined") return null;
  return window.google?.maps?.places || null;
};

const getPlacesStatus = () => getPlacesNamespace()?.PlacesServiceStatus || {};

export const isGooglePlacesReady = () => Boolean(
  getPlacesNamespace()?.AutocompleteService &&
  getPlacesNamespace()?.PlacesService
);

export const fetchGooglePlacePredictions = (input) =>
  new Promise((resolve) => {
    const trimmedInput = (input || "").toString().trim();
    if (!trimmedInput) {
      resolve([]);
      return;
    }

    const places = getPlacesNamespace();
    if (!places?.AutocompleteService) {
      resolve([]);
      return;
    }

    const service = new places.AutocompleteService();
    service.getPlacePredictions({ input: trimmedInput }, (predictions, status) => {
      const { OK, ZERO_RESULTS } = getPlacesStatus();
      if (status !== OK && status !== ZERO_RESULTS) {
        console.warn("[PLACES] Autocomplete lookup failed", { input: trimmedInput, status });
        resolve([]);
        return;
      }

      resolve(Array.isArray(predictions) ? predictions : []);
    });
  });

export const getGooglePlaceDetails = (placeId) =>
  new Promise((resolve) => {
    const normalizedPlaceId = (placeId || "").toString().trim();
    if (!normalizedPlaceId) {
      resolve(null);
      return;
    }

    const places = getPlacesNamespace();
    if (!places?.PlacesService) {
      resolve(null);
      return;
    }

    const service = new places.PlacesService(document.createElement("div"));
    service.getDetails({ placeId: normalizedPlaceId }, (place, status) => {
      const { OK } = getPlacesStatus();
      if (status !== OK || !place) {
        console.warn("[PLACES] Place details lookup failed", {
          placeId: normalizedPlaceId,
          status,
        });
        resolve(null);
        return;
      }

      resolve({
        id: place.place_id || normalizedPlaceId,
        name: place.name || null,
        formattedAddress: place.formatted_address || null,
        addressComponents: Array.isArray(place.address_components)
          ? place.address_components
          : [],
        lat:
          typeof place.geometry?.location?.lat === "function"
            ? place.geometry.location.lat()
            : null,
        lng:
          typeof place.geometry?.location?.lng === "function"
            ? place.geometry.location.lng()
            : null,
      });
    });
  });
